import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { useMarketplacePartnerRegisterPageFormDictionary } from '../../../hooks/useMarketplacePartnerRegisterPageFormDictionary'
import { MarketplacePartnerRegisterPageFormSelectField } from '../MarketplacePartnerRegisterPageFormSelectField'

export const MarketplacePartnerRegisterPageFormTechnicalInformationsMiddlewarePartner: FC =
  () => {
    const { middlewarePartnerOptions } =
      useMarketplacePartnerRegisterPageFormDictionary()

    return (
      <div className="flex flex-col gap-4">
        <span className="text-l">
          <FormattedMessage id="marketplacePartnerRegisterPage.technicalInformations.middlewarePartner.label" />
        </span>
        <MarketplacePartnerRegisterPageFormSelectField
          fieldName="middlewarePartnerName"
          label={
            <FormattedMessage id="marketplacePartnerRegisterPage.technicalInformations.middlewarePartner.placeholder" />
          }
          options={middlewarePartnerOptions}
          required
        />
      </div>
    )
  }
